import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';
import withStyles from '@mui/styles/withStyles'; 
import Logo from '../../assets/images/logo.png'

const styles = theme => ({
    mainDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'center',
        marginBottom:'20px',
        '& img':{
            height:'25px',
            width:'auto !important'
        }
    },

    span:{
        color:'#0F467A',
        fontSize:'13px'
    },

    schoolClass:{
        position:'absolute',
        bottom:'-10px',
        justifyContent:'flex-start',
        width:'80%',
        [theme.breakpoints.between('xs','md')]: {
            width:'95%',
            position:'inherit'
        }
    },

    reviewClass:{
        width:'650px',
        justifyContent:'flex-start',
        [theme.breakpoints.between('xs','md')]: {
            width:'95%',
            position:'inherit'
        }
    },

    companyClass:{
        width:'950px',
        justifyContent:'flex-start',
        margin:'0 auto',
        paddingBottom:'20px',
        [theme.breakpoints.between('xs','md')]: {
            width:'100%',
            position:'inherit',
            justifyContent:'center'
        }
    }
});

class Footer extends React.Component {
    render() {
        const  { classes, schoolAdmission,t,i18n, isreviewPage, companyPage,plans,planId, company } = this.props;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
        const showFooter = false;
        //  planId ? plans['selynk footer'][planId] : company ? plans['selynk footer'][company.planId] : true;
        const divClassname = clsx({
            [classes.mainDiv]: true,
            [classes.schoolClass]: schoolAdmission,
            [classes.reviewClass]: isreviewPage,
            [classes.companyClass]: companyPage,
        });
    return showFooter ? (
        <div className={divClassname}>
            <span className={classes.span} style={{fontFamily}}>{t('footer.title')}</span>
            <a href="https://www.selynk.com/" target="_blank">
                <img src={Logo} alt='selynk' style={isRTL === 'ar' ? {marginRight:'3px'} : {marginLeft:'3px'}} />
            </a>
        </div>
    )
    : null
    }
}

const mapStateToProps = state => {
    return{
        plans: state.plans,
        planId: state.planId,
        company: state.company
    }
}

export default connect(mapStateToProps,null)(withStyles(styles)(withTranslation('common')(Footer)));